import { STORAGE_TOKEN_KEY, STORAGE_LAST_MANAGED_ACCOUNT_KEY } from "../constants";

export const storeMasterToken = (token: string) => {
  localStorage.setItem(STORAGE_TOKEN_KEY, token);
};

export const getMasterTokenFromStorage = (): string | undefined => {
  return localStorage.getItem(STORAGE_TOKEN_KEY) || undefined;
};

export const deleteMasterTokenFromStorage = () => {
  localStorage.removeItem(STORAGE_TOKEN_KEY);
};

export const storeLastManagedAccountTrackingID = (trackingID: string) => {
  localStorage.setItem(STORAGE_LAST_MANAGED_ACCOUNT_KEY, trackingID);
};

export const getLastManagedAccountTrackingID = (): string | undefined => {
  return localStorage.getItem(STORAGE_LAST_MANAGED_ACCOUNT_KEY) || undefined;
};

export const deleteLastManagedAccountTrackingID = () => {
  localStorage.removeItem(STORAGE_LAST_MANAGED_ACCOUNT_KEY);
};
